import { render } from "./user-balance.vue?vue&type=template&id=2ea3bb5a"
import script from "./user-balance.vue?vue&type=script&lang=js"
export * from "./user-balance.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__